import {
  ILabel,
  ILabelSeparatedByLevel,
  IManageLabel,
} from 'Modules/Communication/shared/models/Labels'

export const getMappedLabels = (labels: ILabel[]) => {
  const arr = [...labels]
  arr.sort((a, b) => a.path.toLowerCase().localeCompare(b.path.toLowerCase()))

  arr.map((label) => (label.level = (label.path.match(/\//g) || []).length + 1))

  return arr
}

export const getLabelName = (name: string) =>
  name.substring(name.lastIndexOf('/') + 1)

export const getLabelParent = (labels: ILabel[], label?: ILabel | null) => {
  if (!labels.length || !label || label.level === 1) return ''
  const splitString = label.path.split('/').slice(0, -1)
  return splitString[splitString.length - 1]
}

export const getParentOptions = (labels: ILabel[], label?: ILabel | null) => {
  if (!labels || labels.length === 0) return []
  const arr = [...labels]
  return arr.filter(
    (x) => x.level <= 3 && (!label || !x.path.includes(label.path))
  )
}

export const getLabelPath = (values: IManageLabel) =>
  `${values.isChild ? values.parent + '/' : ''}${values.name}`

export const getIsValidName = (
  labels: ILabel[],
  values: IManageLabel,
  editId?: string
) => {
  const sorted = editId ? labels.filter((x) => x.id !== editId) : labels // Remove the label we are editing, if editmode
  const path = getLabelPath(values)
  return !sorted.some(
    (x) => x.path.trim().toLowerCase() === path.trim().toLowerCase()
  )
}

// recursive function to create a list of labels from a flat structure
// Use depth-first-search to create children that startsWith same path as parent and has higher level
export const createLabelList = (
  labels: ILabel[],
  parent: ILabel = {
    id: '',
    path: '',
    level: 0,
  }
): ILabelSeparatedByLevel[] => {
  const children =
    labels?.filter(
      (label) =>
        label.path.startsWith(parent.path) && label.level > parent.level
    ) || []

  if (children.length > 0) {
    const childrens = children.filter((i) => i.level === parent.level + 1)

    return childrens.map((child) => {
      const childrenLabelList = createLabelList(children, child)

      return {
        ...child,
        children: childrenLabelList,
      }
    })
  }

  return []
}

// Gets the name of the path based on level
export const getPathFromLabelByLevel = (label: string, level: number) =>
  label.split('/')[level - 1]
